var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.992 2H15.02c.26 0 .49-.099.685-.296A.965.965 0 0 0 16 1a.965.965 0 0 0-.294-.704.936.936 0 0 0-.685-.296H.99a.95.95 0 0 0-.697.296A.965.965 0 0 0 0 1c0 .272.098.506.294.704A.95.95 0 0 0 .992 2Z",
    fill: "#014152"
  })));
};

export default SvgMinus;